import { render, staticRenderFns } from "./KlfsWorld.vue?vue&type=template&id=39408548&scoped=true"
import script from "./KlfsWorld.vue?vue&type=script&lang=js"
export * from "./KlfsWorld.vue?vue&type=script&lang=js"
import style0 from "./KlfsWorld.vue?vue&type=style&index=0&id=39408548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39408548",
  null
  
)

export default component.exports